import React from 'react';
import Title from '../components/Title';
import { AiOutlineHeart } from 'react-icons/ai';
import { Sparkle } from 'lucide-react';

const About = () => {
  return (
    <div className="bg-[#fff9f7] pt-28 pb-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl mx-auto bg-[#fbf3f0] border border-[#b0897f] rounded-3xl shadow-md overflow-hidden">
        <div className="text-center py-10 px-6 sm:px-12">
          <Title text1={'OUR STORY'} text2={'ZARVIYA'} />
          <p className="text-[#4b1e1e] text-md max-w-2xl mx-auto mt-4 leading-relaxed">
            At Zarviya, we believe elegance shouldn’t be expensive. Born out of a passion for
            timeless tradition and modern affordability, Zarviya brings you finely crafted fashion
            jewelry that echoes India’s cultural heritage—offering antique-inspired designs that are
            both luxurious and accessible.
          </p>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between px-6 sm:px-12 pb-10 gap-10">
          <div className="md:w-1/2 space-y-6 text-[#422020] text-sm leading-relaxed">
            <h2 className="text-[#65000B] font-forum text-xl font-semibold">What We Stand For</h2>
            <ul className="list-disc pl-5 space-y-3">
              <li>
                <strong>Quality:</strong> Each piece of our fashion jewelry is carefully curated and
                undergoes strict inspection to meet our craftsmanship standards.
              </li>
              <li>
                <strong>Affordability:</strong> Luxury should be accessible—our designs offer
                timeless beauty at honest prices.
              </li>
              <li>
                <strong>Tradition:</strong> From temple-inspired earrings to antique-finish chokers,
                our collection celebrates India’s rich aesthetics and artistry.
              </li>
              <li>
                <strong>Customer-first:</strong> Every order is packed with love and delivered with
                the promise of satisfaction.
              </li>
            </ul>
            <p>
              Whether you're dressing for a festival, a wedding, or adding a touch of elegance to
              your everyday look — Zarviya offers <strong>premium fashion jewelry</strong> that
              speaks your language.
            </p>
            <p className="italic text-[#65000B] pt-4">Thank you for being part of our story.</p>
            <p className="text-md text-[#65000B] flex items-center font-forum font-semibold">
              Team Zarviya <Sparkle className="ml-1 w-4 h-4" />
            </p>
          </div>

          <div className="md:w-1/2">
            <img
              src="https://res.cloudinary.com/dubbklkla/image/upload/v1751414445/IMG_20250702_052858_zwah6p.png"
              alt="Zarviya Fashion Jewelry"
              className="rounded-2xl shadow-lg w-full h-auto object-cover"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
